import React from "react";

const HisPhoneOutgoing = ({ color = "#708FBB", sx = {} }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg
      style={sx}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.707 8.51562V2.51562H16.707"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.707 8.51562L22.707 2.51562"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7075 17.4357V20.4357C22.7086 20.7142 22.6515 20.9899 22.54 21.2451C22.4284 21.5002 22.2648 21.7293 22.0595 21.9176C21.8543 22.1059 21.612 22.2492 21.3482 22.3384C21.0844 22.4277 20.8048 22.4608 20.5275 22.4357C17.4503 22.1014 14.4945 21.0499 11.8975 19.3657C9.48128 17.8304 7.43279 15.7819 5.89745 13.3657C4.20743 10.7569 3.1557 7.78672 2.82745 4.69572C2.80246 4.41919 2.83533 4.14048 2.92395 3.87735C3.01258 3.61421 3.15502 3.37241 3.34222 3.16734C3.52941 2.96227 3.75726 2.79843 4.01124 2.68624C4.26523 2.57406 4.53979 2.51598 4.81745 2.51572H7.81745C8.30276 2.51095 8.77324 2.6828 9.14121 2.99925C9.50918 3.31571 9.74953 3.75517 9.81745 4.23572C9.94408 5.19579 10.1789 6.13845 10.5175 7.04572C10.652 7.40365 10.6811 7.79264 10.6014 8.1666C10.5216 8.54057 10.3363 8.88383 10.0675 9.15572L8.79745 10.4257C10.221 12.9293 12.2939 15.0022 14.7975 16.4257L16.0675 15.1557C16.3393 14.8869 16.6826 14.7016 17.0566 14.6218C17.4305 14.5421 17.8195 14.5712 18.1775 14.7057C19.0847 15.0443 20.0274 15.2791 20.9875 15.4057C21.4732 15.4743 21.9169 15.7189 22.234 16.0932C22.5511 16.4675 22.7196 16.9453 22.7075 17.4357Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisPhoneOutgoing;
